import styled from "styled-components";

export const HeaderWrapper = styled.div`
  width: 100%;
  background-color: var(--theme-color-secondary);
  border-bottom: 1px solid var(--table-border-color);
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  padding: 10px 0;
  transition: all ease-in-out 0.3s;

  @media only screen and (max-width: 800px) {
    grid-template-columns: 100px auto auto;
  }

  @media only screen and (max-width: 600px) {
    grid-template-columns: 50px auto auto;
    gap: 10px;
  }
`;

export const MenuWrapper = styled.div`
  display: flex;
  align-items: center;

  .menu-container {
    width: 110px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media only screen and (max-width: 600px) {
      width: 50px;
    }

    svg {
      width: 100%;
      max-width: 20px;
      height: auto;
      color: var(--text-color-secondary);
      cursor: pointer;
      transition: color ease-in-out 0.3s;

      &:hover {
        color: var(--theme-color-primary);
      }
    }
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all ease-in-out 0.3s;

  img {
    width: 100%;
    max-width: 200px;
    height: auto;

    @media only screen and (max-width: 600px) {
      max-width: 170px;
    }
  }

  @media only screen and (max-width: 800px) {
    justify-content: start;
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  padding-right: 20px;
  gap: 20px;

  @media only screen and (max-width: 600px) {
    gap: 10px;
  }
`;

export const FullScreenButton = styled.button`
  width: 16px;
  height: 16px;
  padding: 0;
  margin: 0;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-color-secondary);
  transition: color ease-in-out 0.3s;

  &:hover {
    color: var(--theme-color-primary);
  }

  svg {
    width: 100%;
    height: auto;
  }

  @media only screen and (max-width: 600px) {
    width: 14px;
    height: 14px;
  }
`;